import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from 'environments/environment';
import { PagePrivilegesModel } from '@app/shared/models/peripherals/page-privileges';

@Injectable()
export class UserPrivilegesService {
    
    constructor(private http: HttpClient) {}

    createPagePrivileges(queryData: PagePrivilegesModel): Observable<any> {
        return this.http.post(`${environment.api}page-privileges`, queryData);  
    }
  
    updatePagePrivileges(queryData: PagePrivilegesModel): Observable<any> {
        return this.http.put(`${environment.api}page-privileges`, queryData);
    }

    deletePagePrivileges(pagePrivilegeId: number): Observable<any> {
        return this.http.delete(`${environment.api}page-privileges/${pagePrivilegeId}`);
    }

    getAllPagePrivileges(): Observable<PagePrivilegesModel[]> {
        return this.http.get<PagePrivilegesModel[]>(`${environment.api}page-privileges`);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/user-privileges/user-privileges.service.ts